
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Download } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { generateCsvTemplate } from '@/utils/csvTemplateGenerator';

export const CsvColumnRequirements = () => {
  return (
    <div className="space-y-3">
      <div className="bg-blue-50 rounded-lg p-3 border border-blue-200">
        <h4 className="font-medium text-gray-900 mb-2">CSV Requirements</h4>
        
        <div className="space-y-2 text-sm">
          <div>
            <span className="font-medium text-red-700">Required: </span>
            <Badge variant="destructive" className="text-xs mr-1">email</Badge>
            <Badge variant="destructive" className="text-xs mr-1">first_name</Badge>
            <Badge variant="destructive" className="text-xs">last_name</Badge>
          </div>
          
          <div>
            <span className="font-medium text-blue-700">Optional: </span>
            <Badge variant="secondary" className="text-xs">role</Badge>
            <span className="text-gray-600 ml-2">(defaults to "member")</span>
          </div>
        </div>
      </div>

      <div className="bg-gray-50 rounded-lg p-3 border">
        <div className="flex items-center justify-between mb-2">
          <h4 className="font-medium text-gray-900 text-sm">Sample Format:</h4>
          <Button
            variant="outline"
            size="sm"
            onClick={generateCsvTemplate}
            className="text-xs h-7"
          >
            <Download className="h-3 w-3 mr-1" />
            Template
          </Button>
        </div>
        <div className="bg-white rounded border p-2 font-mono text-xs text-gray-700">
          <div className="text-gray-500">email,first_name,last_name,role</div>
          <div>john@example.com,John,Doe,member</div>
        </div>
      </div>
    </div>
  );
};
